module.exports = __webpack_public_path__ + "img/IndiaFlag.dfa10c2a.svg";